var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('select',{attrs:{"name":"","id":""}},[_c('option',{attrs:{"value":""}}),_c('option',{attrs:{"value":""}})])
}]

export { render, staticRenderFns }